/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GantryWorkflowOutput } from '../../models/gantry-workflow-output';

export interface GetGantryWorkflow$Params {
  SerialNumber: string;
  MaterialNumber: number;
  EventSource: string;
}

export function getGantryWorkflow(http: HttpClient, rootUrl: string, params: GetGantryWorkflow$Params, context?: HttpContext): Observable<StrictHttpResponse<GantryWorkflowOutput>> {
  const rb = new RequestBuilder(rootUrl, getGantryWorkflow.PATH, 'get');
  if (params) {
    rb.path('SerialNumber', params.SerialNumber, {});
    rb.path('MaterialNumber', params.MaterialNumber, {});
    rb.path('EventSource', params.EventSource, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GantryWorkflowOutput>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getGantryWorkflow.PATH = '/api/CTSystemStatus/gantryworkflow/{SerialNumber}/{MaterialNumber}/{EventSource}';
getGantryWorkflow.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getGantryWorkflow.ROOTURL = '/ctsystem';
